import { AlarmClock, ListChecks } from 'lucide-react';
import type { TaskAlert, TaskExtProps } from '../../app/modules';
import { Badge } from '../../components/ui/Badge';
import { formatDateTime } from '../../lib/dates';
import { ALERT_LABEL } from '../tasks/TaskBits';
import { readTaskExt } from './api';

/*
 * Значки модуля в рядку переліку й на картці дошки: прогрес чек-листа «3/5» (зелений, коли все виконано)
 * і прострочений строк реакції (червоний, з текстом). Лише коли в задачі є дані модуля.
 */
/** Попередження для картки дошки: прострочений строк реакції (на картці він іде в рядок попереджень, а не значком). */
export function automationTaskAlerts({ ext }: TaskExtProps): TaskAlert[] {
  const breached = (readTaskExt(ext)?.sla ?? []).filter((t) => t.breached);
  if (!breached.length) return [];
  return [{ key: 'sla', tone: 'danger', label: 'Реакція прострочена', detail: breached.map((t) => `${t.name}: до ${formatDateTime(t.dueAt)}`).join('; ') }];
}

export function AutomationTaskBadges({ ext, variant }: TaskExtProps & { variant: 'row' | 'card' }) {
  const data = readTaskExt(ext);
  if (!data) return null;
  const c = data.checklist;
  const breached = (data.sla ?? []).filter((t) => t.breached);
  return (
    <>
      {/* Попередження — першим: у вузькому рядку видно те, що стоїть на початку. */}
      {variant === 'row' && breached.length > 0 && (
        <Badge tone="danger" icon={<AlarmClock className="size-3" aria-hidden />} title={`Реакція прострочена — ${breached.map((t) => `${t.name}: до ${formatDateTime(t.dueAt)}`).join('; ')}`} alert>
          <span className={ALERT_LABEL}>Реакція прострочена</span>
        </Badge>
      )}
      {c && c.total > 0 && (
        <Badge
          tone={c.done >= c.total ? 'success' : 'neutral'}
          icon={<ListChecks className="size-3" aria-hidden />}
          title={`Чек-лист: виконано ${c.done} з ${c.total}${c.requiredOpen ? `; невиконаних обов’язкових: ${c.requiredOpen}` : ''}`}
        >
          <span className="tnum">
            <span className="sr-only">Чек-лист </span>
            {c.done}/{c.total}
          </span>
        </Badge>
      )}
    </>
  );
}
